import { AccountActionTypes } from './constants';

const INIT_STATE = {
    data: [],
    loading: false,
    error: null,
    updateSuccess: null,
    createSuccess: null,
};

const Account = (state = INIT_STATE, action) => {
    switch (action.type) {
        case AccountActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AccountActionTypes.CREATE_ACCOUNT:
                    return { ...state, data: action.payload.data, loading: false, createSuccess: true };
                case AccountActionTypes.GET_ACCOUNTS:
                    return { ...state, data: action.payload.data, loading: false };
                case AccountActionTypes.GET_ACCOUNT_BY_ID:
                    return { ...state, data: action.payload.data, loading: false };
                case AccountActionTypes.GET_ACCOUNTS_BY_USER:
                    return { ...state, data: action.payload.data, loading: false };
                case AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION:
                    return { ...state, data: action.payload.data, loading: false };                    
                case AccountActionTypes.UPDATE_ACCOUNT:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                case AccountActionTypes.DELETE_ACCOUNT:
                    return {
                        ...state,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                case AccountActionTypes.SEND_ACCOUNT_EMAIL:
                    return { ...state, data: action.payload.data, loading: false };
                default:
                    return { ...state };
            }
        case AccountActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AccountActionTypes.CREATE_ACCOUNT:
                    return { ...state, error: action.payload, loading: false };
                case AccountActionTypes.GET_ACCOUNTS:
                    return { ...state, error: action.payload, loading: false };
                case AccountActionTypes.GET_ACCOUNT_BY_ID:
                    return { ...state, error: action.payload, loading: false };
                case AccountActionTypes.GET_ACCOUNTS_BY_USER:
                    return { ...state, error: action.payload, loading: false };
                case AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION:
                    return { ...state, error: action.payload, loading: false };                    
                case AccountActionTypes.UPDATE_ACCOUNT:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                case AccountActionTypes.DELETE_ACCOUNT:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };                
                case AccountActionTypes.SEND_ACCOUNT_EMAIL:
                    return { ...state, error: action.payload, loading: false };
                default:
                    return { ...state };
            }
        case AccountActionTypes.CREATE_ACCOUNT:
            return { ...state, loading: true };
        case AccountActionTypes.GET_ACCOUNTS:
            return { ...state, loading: true };
        case AccountActionTypes.GET_ACCOUNT_BY_ID:
            return { ...state, loading: true };
        case AccountActionTypes.GET_ACCOUNTS_BY_USER:
            return { ...state, loading: true };
        case AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION:
            return { ...state, loading: true };
        case AccountActionTypes.UPDATE_ACCOUNT:
            return {
                ...state,
                id: action.payload.id,
                data: action.payload.data,
                loading: false,
            };
        case AccountActionTypes.DELETE_ACCOUNT:
            return {
                ...state,
                data: action.payload.data,
                loading: false,
            };
        case AccountActionTypes.SEND_ACCOUNT_EMAIL:
            return { ...state, loading: true };
        case AccountActionTypes.RESET_ACCOUNTS:
            return INIT_STATE;
        default:
            return { ...state, updateSuccess: null, createSuccess: null };
    }
};

export default Account;
